import { httpClient } from "@/services";
import { trimLeadingDisabledWeek } from "@/helper";

export default {
	state: {
		duties: null,
		userData: null,
		managerData: null,
		monthData: null,
		calendarData: null,
		calendarMonthData: null,
		overtime: null,
		total_schedule_time: null,
		total_work_time: null,
		myInformation: null,
		eventsList: null,
		month_calendar: null,
		month_info: null,
		total_vocation: null,

		accountUsers_limit: null,
		accountUsers_order: null,
		accountUsers_rows: null,
		accountUsers_sort: null,
		accountUsers_total: null,
		accountUsers_filter: null,
		accountUsers_filter_department: null,
		accountUsers_filter_location: null,
		accountUsers_filter_name: null,
		accountUsers_filter_company: null,
		accountUsers_filter_office: null,
		accountUsers_filter_position: null,

		accountRequestList: [],
		accountRequestFilters: [],

		accountNotesList: null,
		accountNotesFilters: null,
		accountCountNotes: null,
		accountCountVacation: null,
		accountVacationRequestEdit: null,

	},
	mutations: {
		updateCountNotes(state, { count, vacation }) {
			state.accountCountNotes = count;
			state.accountCountVacation = vacation;
		},
		updateUser(state, {
			duties,
			user,
			managers,
			month,
			calendar,
			overtime,
			total_schedule_time,
			total_work_time,
			month_calendar,
			month_info,
			total_vocation
		}) {
			const mock = [
				{
					"date": "2025-09-28",
					"isDisabled": true
				},
				{
					"date": "2025-09-29",
					"isDisabled": true
				},
				{
					"date": "2025-09-30",
					"isDisabled": true
				},
				{
					"date": "2025-10-01",
					"total_time": "08:52:00",
					"name": "Wednesday",
					"check_in": "09:21:47",
					"check_out": "18:14:30",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-02",
					"total_time": "10:10:00",
					"name": "Thursday",
					"check_in": "08:20:17",
					"check_out": "18:30:38",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-03",
					"total_time": "08:47:00",
					"name": "Friday",
					"check_in": "09:12:21",
					"check_out": "17:59:37",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-04",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-05",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-06",
					"total_time": "08:49:00",
					"name": "Monday",
					"check_in": "09:16:06",
					"check_out": "18:05:31",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-07",
					"total_time": "09:45:00",
					"name": "Tuesday",
					"check_in": "08:24:25",
					"check_out": "18:10:13",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-08",
					"total_time": "08:20:00",
					"name": "Wednesday",
					"check_in": "09:50:10",
					"check_out": "18:10:24",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-09",
					"total_time": "09:09:00",
					"name": "Thursday",
					"check_in": "08:53:58",
					"check_out": "18:03:53",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-10",
					"total_time": "09:10:00",
					"name": "Friday",
					"check_in": "08:53:16",
					"check_out": "18:03:35",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-11",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-12",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-13",
					"total_time": "08:34:00",
					"name": "Monday",
					"check_in": "09:28:23",
					"check_out": "18:02:55",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-14",
					"total_time": "09:53:00",
					"name": "Tuesday",
					"check_in": "08:33:10",
					"check_out": "18:26:56",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-15",
					"total_time": "07:10:00",
					"name": "Wednesday",
					"check_in": "11:11:41",
					"check_out": "18:22:19",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-16",
					"total_time": "09:13:00",
					"name": "Thursday",
					"check_in": "08:57:13",
					"check_out": "18:11:11",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-17",
					"total_time": "08:59:00",
					"name": "Friday",
					"check_in": "09:17:21",
					"check_out": "18:16:54",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-18",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-19",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-20",
					"total_time": "09:05:00",
					"name": "Monday",
					"check_in": "09:04:53",
					"check_out": "18:10:47",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-21",
					"total_time": "09:38:00",
					"name": "Tuesday",
					"check_in": "08:21:38",
					"check_out": "18:00:20",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-22",
					"total_time": "09:16:00",
					"name": "Wednesday",
					"check_in": "08:59:17",
					"check_out": "18:15:21",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-23",
					"total_time": "09:25:00",
					"name": "Thursday",
					"check_in": "08:38:49",
					"check_out": "18:04:35",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-24",
					"total_time": "03:20:00",
					"name": "Friday",
					"check_in": "08:20:50",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": true,
					"user_agent_out": "",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-25",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-26",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-27",
					"total_time": "09:16:04",
					"name": "Monday",
					"check_in": "08:59:17",
					"check_out": "18:15:21",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-28",
					"total_time": "00:00:00",
					"name": "Tuesday",
					"check_in": "09:08:17",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-29",
					"total_time": "00:00:00",
					"name": "Wednesday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-30",
					"total_time": "00:00:00",
					"name": "Thursday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-31",
					"total_time": "00:00:00",
					"name": "Friday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-11-01",
					"isDisabled": true
				}
			];

			state.calendarMonthData = mock;
			state.duties = duties;
			state.userData = user;
			state.managerData = managers;
			state.monthData = month;
			state.calendarData = trimLeadingDisabledWeek(calendar);
			state.overtime = overtime;
			state.total_schedule_time = total_schedule_time;
			state.total_work_time = total_work_time;
			state.month_calendar = month_calendar;
			state.month_info = month_info;
			state.total_vocation = total_vocation;
		},
		updateEvents(state, { events }) {
			state.eventsList = events;
		},
		updateAccountUsersList(state, payload) {
			const { limit, order, rows, sort, total } = payload;
			state.accountUsers_limit = limit;
			state.accountUsers_order = order;
			state.accountUsers_rows = rows;
			state.accountUsers_sort = sort;
			state.accountUsers_total = total;
		},
		updateAccountUsersFilters(state, { filter }) {
			state.accountUsers_filter = filter;

			const { filter_department, filter_location, filter_name, filter_company, filter_office, filter_position, } = filter;
			state.accountUsers_filter_department = filter_department;
			state.accountUsers_filter_location = filter_location;
			state.accountUsers_filter_name = filter_name;
			state.accountUsers_filter_company = filter_company;
			state.accountUsers_filter_office = filter_office;
			state.accountUsers_filter_position = filter_position;
		},
		updateMyInformation(state, payload) {
			state.myInformation = payload;
		},
		updateAccountNotesList(state, payload) {
			const { filters, items, } = payload;
			state.accountNotesList = items;
			state.accountNotesFilters = filters;
		},
		updateAccountUpdateVacationRequestEdit(state, payload) {
			state.accountVacationRequestEdit = payload;
		},
		updateAccountRequestList(state, payload) {
			const { filters, items, } = payload;
			state.accountRequestList = items;
			state.accountRequestFilters = filters;
		},
		updateDeleteAccountVacationRequestList(state, { id }) {
			const index = state.accountRequestList.findIndex(item => item.id === id);

			if (index !== -1) {
				state.accountRequestList.splice(index, 1);
			}
		},
	},
	actions: {
		async getAccountNotesListFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/info/notes/list', payload);
				if (data && !data.status) {
					commit('updateAccountNotesList', data);
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountNotesList({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/info/notes/list');
				if (data && !data.status) {
					commit('updateAccountNotesList', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountVacationRequestFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/info/vacation/request/list', payload);
				if (data && !data.status) {
					commit('updateAccountRequestList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountCheckVacationRequest(ctx, values) {
			try {
				return await httpClient.post('/info/vacation/check', values);
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountVacationRequestList({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/info/vacation/request/list');
				if (data && !data.status) {
					commit('updateAccountRequestList', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async deleteAccountVacationRequest({ dispatch, commit }, id) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.delete(`/info/vacation/request/${ id }`);
				if (data && data.status) {
					commit('updateDeleteAccountVacationRequestList', { id });
					dispatch('setAlert', { type: "success", message: "The leave request has been successfully deleted. 🗑️" });
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountUpdateVacationRequest({ dispatch }, value ) {
			const { id } = value;
			try {
				const { data } = await httpClient.put( `/info/vacation/request/${ id }`, value );
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Read status successfully changed 👌" });
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountUpdateVacationRequestEdit({ dispatch, commit }, value ) {
			const { id } = value;
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get( `/info/vacation/request/${ id }/edit` );
				if (data && data.status) {
					commit('updateAccountUpdateVacationRequestEdit', data);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				dispatch('actionPreloader', false);

				console.error(e);
			}
		},
		async getAccountUpdateVacationRequestEditPut({ dispatch }, value ) {
			const { id } = value;
			try {
				dispatch('actionPreloader', true);
				await httpClient.put( `/info/vacation/request/${ id }`, value );
				dispatch('actionPreloader', false);
			} catch (e) {
				dispatch('actionPreloader', false);

				console.error(e);
			}
		},
		async getEvents({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get('/info/event');
				if (data && !data.status) {
					commit('updateEvents', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getUser({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/user');
				if (data && !data.status) {
					commit('updateUser', data);
				} else {
					commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async getMyInformation({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get(`info/my-information` );
				if (data && !data.status) {
					commit('updateMyInformation', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountUsersList({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get(`info/users` );
				if (data && !data.status) {
					commit('updateAccountUsersList', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async filtersAccountUsersList({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`info/users/filters`, values );
				if (data && !data.status) {
					commit('updateAccountUsersFilters', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async updateAccountUsersList({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`info/users/list`, values );
				if (data && !data.status) {
					commit('updateAccountUsersList', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async getUserСheck({ dispatch }, args) {
			try {
				const { status } = args;
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/check/${ status }`, args );
				if (data && data.status && status === 1) {
					dispatch('setAlert', { type: "success", message: "You are logged in, have a nice day! 😉" });
				} else if (data && data.status && status === 2) {
					dispatch('setAlert', { type: "success", message: "You have finished your working day. Have a nice day! 🫡" });
				} else if (data && !data.status && status === 1) {
					dispatch('setAlert', { type: "error", message: "You already have a checkin today. 🫠" });
				} else if (data && !data.status && status === 2) {
					dispatch('setAlert', { type: "error", message: "You are already logged out. 🫠" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
				dispatch('setAlert', { type: "error", message: "Sorry, but there was an error on the server, please contact the administrator 🤯" });
			}
		},
		async getUpdateCalendar({ dispatch, commit }, value) {
			try {
				const { data } = await httpClient.post('/user', value);
				if (data && !data.status) {
					commit('updateUser', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEditPassword(ctx, values) {
			try {
				return await httpClient.post('/user/update', values);
			} catch (e) {
				console.error(e);
			}
		},
		async getCountNotes({ commit }) {
			try {
				const { data } = await httpClient.get(`/info/notes/count` );
				commit('updateCountNotes', data);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountUpdateNotes({ dispatch }, value ) {
			const { id, status } = value;
			try {
				await httpClient.put( `info/notes/${ id }`, { status } );
				dispatch('setAlert', { type: "success", message: "Read status successfully changed 👌" });
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		duties: s => s.duties,
		userData: s => s.userData,
		managerData: s => s.managerData,
		monthData: s => s.monthData,
		calendarData: s => s.calendarData,
		calendarMonthData: s => s.calendarMonthData,
		overtime: s => s.overtime,
		total_schedule_time: s => s.total_schedule_time,
		total_work_time: s => s.total_work_time,
		month_calendar: s => s.month_calendar,
		month_info: s => s.month_info,
		total_vocation: s => s.total_vocation,
		myInformation: s => s.myInformation,
		eventsList: s => s.eventsList,
		accountUsers_limit: s => s.accountUsers_limit,
		accountUsers_order: s => s.accountUsers_order,
		accountUsers_rows: s => s.accountUsers_rows,
		accountUsers_sort: s => s.accountUsers_sort,
		accountUsers_total: s => s.accountUsers_total,
		accountUsers_filter: s => s.accountUsers_filter,
		accountUsers_filter_department: s => s.accountUsers_filter_department,
		accountUsers_filter_location: s => s.accountUsers_filter_location,
		accountUsers_filter_name: s => s.accountUsers_filter_name,
		accountUsers_filter_company: s => s.accountUsers_filter_company,
		accountUsers_filter_office: s => s.accountUsers_filter_office,
		accountUsers_filter_position: s => s.accountUsers_filter_position,
		accountNotesList: s => s.accountNotesList,
		accountNotesFilters: s => s.accountNotesFilters,
		accountCountNotes: s => s.accountCountNotes,
		accountCountVacation: s => s.accountCountVacation,
		accountRequestList: s => s.accountRequestList,
		accountRequestFilters: s => s.accountRequestFilters,
		accountVacationRequestEdit: s => s.accountVacationRequestEdit,
	}
};
